import request from '@/utils/request'

// export function homeCount(query) {
//   return request({
//     url: '/api/home/homeCount',
//     method: 'get',
//     params: query
//   })
// }
// // 今日收益折线图
// export function todayAmount(query) {
//   return request({
//     url: '/api/home/todayAmount',
//     method: 'get',
//     params: query
//   })
// }
// // 阶段收益折线图
// export function sumAmount(query) {
//   return request({
//     url: '/api/home/sumAmount',
//     method: 'post',
//     params: query
//   })
// }

// 今日 / 本月 / 近3月 / 近6月 / 今年
export function qryProfit(query) {
  return request({
    url: '/api/smallProgram/qryProfit',
    method: 'post',
    params: query
  })
}

// 代理商收益
export function qryAgentInfo(query) {
  return request({
    url: '/api/smallProgram/qryAgentInfo',
    method: 'post',
    params: query
  })
}

// 场地方收益
export function qryFieldInfo(query) {
  return request({
    url: '/api/smallProgram/qryFieldInfo',
    method: 'post',
    params: query
  })
}

// 查询设备流水记录
export function qryDeviceFlowRecord(query) {
  return request({
    url: '/api/smallProgram/qryDeviceFlowRecord',
    method: 'post',
    params: query
  })
}

// 查询场地流水记录
export function qryFieldFlowRecord(query) {
  return request({
    url: '/api/smallProgram/qryFieldFlowRecord',
    method: 'post',
    params: query
  })
}

// GET /api/home/homeCount 首页相关数据（头部数据）
export function homeCount(query) {
  return request({
    url: '/api/home/homeCount',
    params: query
  })
}

// POST /api/home/sumAmount 阶段收益折线图
export function sumAmount() {
  return request({
    url: '/api/home/sumAmount',
    method: 'post'
  })
}

// GET /api/newAdd/userGrowth 用户增长
export function userGrowth(query) {
  return request({
    url: '/api/newAdd/userGrowth',
    params: query
  })
}

// GET /api/newAdd/qryDeviceProvince 获取设备铺装省份(数量)
export function qryDeviceProvince(query) {
  return request({
    url: '/api/newAdd/qryDeviceProvince',
    params: query
  })
}

// GET /api/home/fieldInfo 首页场地使用率（月）
export function homeFieldInfo(query) {
  return request({
    url: '/api/home/fieldInfo',
    params: query
  })
}

// GET /api/newAdd/qryDeviceInstallCount 查询设备安装数量
export function qryDeviceInstallCount(query) {
  return request({
    url: '/api/newAdd/qryDeviceInstallCount',
    params: query
  })
}
